import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerIsOpen } from "../store/drawerSlice";

const PathChangeDrawer = ({ children }) => {
  const dispatch = useDispatch();
  const [isAnimating, setIsAnimating] = useState(false);
  const drawerIsOpen = useSelector((state) => state.drawer.drawerIsOpen);

  useEffect(() => {
    setIsAnimating(true);

    const slideOutTimer = setTimeout(() => {
      setIsAnimating(false); // Step 2: Slide out after 1 second
    }, 2000);

    const hideTimer = setTimeout(() => {
      dispatch(setDrawerIsOpen(false)); // Step 3: Hide the drawer after animation
    }, 4000);

    return () => {
      clearTimeout(slideOutTimer);
      clearTimeout(hideTimer);
    };
  }, [drawerIsOpen, dispatch]);

  return (
    drawerIsOpen && (
      <div
        className={`fixed left-0 top-0 w-screen h-screen flex items-center justify-center bg-[#0e1134] text-primary-light shadow-lg z-[1000] overflow-hidden
          ${isAnimating ? "animate-slideInLeft" : "animate-slideOutRight"}`}
        style={{ animationDuration: "2s" }}
      >
        <Logo h={164} w={184} />
      </div>
    )
  );
};

export default PathChangeDrawer;
